export const darkVariant = {
  root: {
    border: 'none',
    backgroundColor: 'neutral.900',
    padding: 1,
  },
  closeTrigger: {
    marginLeft: 'auto',
    boxSize: '24px',
    color: 'neutral.300',
    '&:not([data-disabled=true]):hover': {
      color: 'skyBlue',
      cursor: 'pointer',
    },
  },
};
